import { TooltipButton } from "@/components/atoms/TooltipButton";
import { CheckProjectAccess } from "@/features/rbac/components/molecules/CheckProjectAccess";
import { Archive, ArchiveRestore, Pencil, Trash2 } from "lucide-react";
import { Link } from "react-router-dom";
import { ListRowProps } from ".";


export const ListRow = ({
    index,
    link,
    title,
    description,
    createdAt,
    showArchiveButton = false,
    onEdit,
    onArchive,
    onRestore,
    onDelete,
}: ListRowProps) => {
    return (
        <div className={`flex items-center justify-between p-2 bg-gray-100 rounded-md gap-3 hover:bg-gray-200 transition-all duration-200 ease-in-out`}>
            <div className="self-start">
                <p className="min-w-5">{index}</p>
            </div>

            <Link to={link} className="flex items-center w-full gap-2">
                <div className="w-full cursor-pointer">
                    <p className="w-full pr-4 text-xs font-medium line-clamp-1">{title}</p>
                    <p className="w-full pr-4 text-xs line-clamp-2">{description}</p>
                    {createdAt && (<p className="w-full pr-4 text-[10px] line-clamp-1">{createdAt}</p>)}
                </div>
            </Link>

            <div className="flex items-center justify-center gap-1">
                <CheckProjectAccess question_update survey_update>
                    <TooltipButton tooltipContent="Edit" size='action' onClick={onEdit}>
                        <Pencil size={16} />
                    </TooltipButton>
                    {showArchiveButton && (
                        <TooltipButton tooltipContent="Archive" variant='accent' size='action' onClick={onArchive}>
                            <Archive size={16} />
                        </TooltipButton>
                    )}
                    {!showArchiveButton && (
                        <TooltipButton tooltipContent="Restore" variant='accent' size='action' onClick={onRestore}>
                            <ArchiveRestore size={16} />
                        </TooltipButton>
                    )}
                </CheckProjectAccess>
                <CheckProjectAccess question_delete survey_delete>
                    {!showArchiveButton && (
                        <TooltipButton tooltipContent="Delete" variant='destructive' size='action' onClick={onDelete}>
                            <Trash2 size={16} />
                        </TooltipButton>
                    )}
                </CheckProjectAccess>
            </div>
        </div>
    )
}
